export default "__VITE_ASSET__D4oM87Ky__"